import { AllowedRoleFragment, PermissionKey_enum, RoleKey_enum } from '../graphql/hasura/generated';

import { getPropertyFeatureFlags, PropertyWithFeatureFlags } from './getPropertyFeatureFlags';

// STRATIS roles that will have limitations applied in Chirp Admin Panel
export const LIMITED_STRATIS_ROLES = [
  RoleKey_enum.STRATIS_PROPERTY_MANAGER,
  RoleKey_enum.STRATIS_OFFICE_STAFF,
  RoleKey_enum.STRATIS_MAINTENANCE,
];

// Ensure STRATIS 4.x users cannot perform these actions within Chirp Admin Panel
export const DENIED_STRATIS_PERMISSIONS = [
  PermissionKey_enum.Credential_Create,
  PermissionKey_enum.Credential_Update,
  PermissionKey_enum.Credential_Delete,
  PermissionKey_enum.PinCode_Create,
  PermissionKey_enum.PinCode_Update,
  PermissionKey_enum.PinCode_Delete,
  PermissionKey_enum.PinCode_GenerateRandomByUser,
  PermissionKey_enum.Unit_Create,
  PermissionKey_enum.Unit_Update,
  PermissionKey_enum.Unit_Delete,
  PermissionKey_enum.UnitGroup_Create,
  PermissionKey_enum.UnitGroup_Update,
  PermissionKey_enum.UnitGroup_Delete,
  PermissionKey_enum.User_UpdateAccountStatus,
];

// Limit the roles that STRATIS 4.x users can grant/revoke within Chirp Admin Panel
export const canStratisGrantOrRevokeRole = (
  role: AllowedRoleFragment,
  property: PropertyWithFeatureFlags,
) => {
  const featureFlags = getPropertyFeatureFlags(property);

  return (
    role.key === RoleKey_enum.VENDOR_PASS && featureFlags.VENDOR_PASSCODES
  );
};
